import m from "mithril";

const LoanPrediction = {
    oninit: function() {
        this.formData = {
            nama: '',
            status_pernikahan: '',
            status_rumah: '',
            penghasilan: '',
            umur: ''
        };
        this.predictionResult = null;
        this.isLoading = false;

        // Initialize session management variables (removed external API dependencies)
        this.konfirm = 0;
        this.out = 0;
        this.autosave = 0 * 60000;
        this.autologout = 0;
        this.status_idle = 0;
        this.remaining = 0;

        // Dialog states
        this.showLogoutDialog = false;
        this.showLoginConfirmDialog = false;
        this.logoutCountdown = 0;
        this.idleWarningShown = false;

        // Initialize auto logout if configured
        this.initializeAutoLogout();

        // Initialize server-sent events for session monitoring
        this.initializeServerSentEvents();

        // Keep-alive disabled due to CORS issues
    },

    // Keep-alive functionality removed due to CORS issues

    onremove: function() {
        // Cleanup on component removal
        clearInterval(this.countdownInterval);
        clearTimeout(this.idleTimer);
        clearTimeout(this.warningTimer);
    },

    // Removed getClientIP function - no longer needed

    initializeAutoLogout: function() {
        if (this.autologout > 0) {
            this.startIdleTimeout();
        }
    },

    startIdleTimeout: function() {
        const warningLength = 10;
        const totalTimeout = this.autologout * 60 * 1000; // Convert minutes to milliseconds

        // Reset idle timer on user activity
        const resetTimer = () => {
            clearTimeout(this.idleTimer);
            clearTimeout(this.warningTimer);
            this.idleWarningShown = false;
            this.showLogoutDialog = false;
            this.remaining = totalTimeout / 1000;

            this.idleTimer = setTimeout(() => {
                this.showIdleWarning();
            }, totalTimeout - (warningLength * 1000));
        };

        // Event listeners for user activity
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        events.forEach(event => {
            document.addEventListener(event, resetTimer, true);
        });

        resetTimer(); // Start the timer
    },

    showIdleWarning: function() {
        if (!this.idleWarningShown) {
            this.idleWarningShown = true;
            this.showLogoutDialog = true;
            this.logoutCountdown = 10; // 10 seconds countdown

            this.countdownInterval = setInterval(() => {
                this.logoutCountdown--;
                if (this.logoutCountdown <= 0) {
                    clearInterval(this.countdownInterval);
                    this.handleLogout();
                }
                m.redraw();
            }, 1000);

            m.redraw();
        }
    },

    initializeServerSentEvents: function() {
        // SSE functionality disabled - this is a static loan prediction page
        // No external API dependencies needed for client-side prediction calculations
        console.log('SSE disabled - using standalone loan prediction functionality');
    },

    startLogoutCountdown: function() {
        this.logoutCountdown = 5; // 5 seconds countdown as in original

        this.countdownInterval = setInterval(() => {
            this.logoutCountdown--;
            if (this.logoutCountdown <= 0) {
                clearInterval(this.countdownInterval);
                this.handleForceLogout();
            }
            m.redraw();
        }, 1000);
    },

    handleLogout: function() {
        clearInterval(this.countdownInterval);
        clearTimeout(this.idleTimer);
        clearTimeout(this.warningTimer);
        this.showLogoutDialog = false;

        // Simulate logout - redirect to login page
        window.location.href = '/login';
    },

    handleForceLogout: function() {
        clearInterval(this.countdownInterval);
        this.showLogoutDialog = false;

        // Force logout
        this.logoutAccess();
    },

    handleLoginConfirm: function(shouldContinue) {
        if (shouldContinue) {
            this.updateTimeLogIP();
            this.konfirm = 0;
        } else {
            this.logoutAccess();
        }
        this.showLoginConfirmDialog = false;
        m.redraw();
    },

    logoutAccess: function() {
        // Clear local storage/session storage
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('jwt') ||
                key.startsWith('username') ||
                key.startsWith('role') ||
                key.startsWith('fullName') ||
                key.startsWith('email') ||
                key.startsWith('phone')) {
                localStorage.removeItem(key);
            }
        });

        Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith('jwt') ||
                key.startsWith('username') ||
                key.startsWith('role') ||
                key.startsWith('fullName') ||
                key.startsWith('email') ||
                key.startsWith('phone')) {
                sessionStorage.removeItem(key);
            }
        });

        window.location.href = '/login'; // Redirect to local login page
    },

    // Removed updateTimeLogIP function - no external API needed

    // Keep-alive function removed due to CORS issues

    handleInputChange: function(field, value) {
        if (field === 'penghasilan') {
            // Format income with Indonesian locale (add thousand separators)
            const numericValue = value.replace(/[^\d]/g, '');
            this.formData[field] = numericValue ? new Intl.NumberFormat('id-ID').format(numericValue) : '';
        } else {
            this.formData[field] = value;
        }
    },

    handleIncomeInput: function(e) {
        // Handle raw input for income field to allow real-time formatting
        const rawValue = e.target.value.replace(/[^\d]/g, '');
        const formattedValue = rawValue ? new Intl.NumberFormat('id-ID').format(parseInt(rawValue)) : '';
        this.formData.penghasilan = formattedValue;
        // Update the input value directly
        e.target.value = formattedValue;
    },

    handleSubmit: function(e) {
        e.preventDefault();

        // Basic validation
        if (!this.formData.nama || !this.formData.status_pernikahan || !this.formData.status_rumah ||
            !this.formData.penghasilan || !this.formData.umur) {
            alert('Harap isi semua field yang diperlukan');
            return;
        }

        this.isLoading = true;

        // Simulate API call - replace with actual prediction logic
        setTimeout(() => {
            // Mock prediction result based on form data
            const predictionScore = this.calculatePredictionScore();
            this.predictionResult = {
                score: predictionScore,
                category: predictionScore >= 80 ? 'Sangat Baik' :
                         predictionScore >= 60 ? 'Baik' :
                         predictionScore >= 40 ? 'Sedang' : 'Berisiko',
                recommendation: this.getRecommendation(predictionScore)
            };
            this.isLoading = false;
            m.redraw();
        }, 1500);
    },

    calculatePredictionScore: function() {
        let score = 50; // Base score

        // Marital status factor
        if (this.formData.status_pernikahan === 'MENIKAH') {
            score += 15;
        } else if (this.formData.status_pernikahan === 'SINGLE') {
            score += 10;
        }

        // Housing status factor
        if (this.formData.status_rumah === 'Sendiri') {
            score += 20;
        } else if (this.formData.status_rumah === 'Kontrak') {
            score += 5;
        }

        // Income factor (simplified)
        const income = parseInt(this.formData.penghasilan.replace(/[^\d]/g, ''));
        if (income >= 8000000) {
            score += 25;
        } else if (income >= 5000000) {
            score += 15;
        } else if (income >= 3000000) {
            score += 10;
        } else if (income >= 2000000) {
            score += 5;
        }

        // Age factor
        const age = parseInt(this.formData.umur);
        if (age >= 25 && age <= 55) {
            score += 15;
        } else if (age >= 18 && age <= 65) {
            score += 10;
        }

        return Math.min(score, 100);
    },

    getRecommendation: function(score) {
        if (score >= 80) {
            return 'Pelanggan ini memiliki risiko kredit yang sangat rendah. Disarankan untuk memberikan persetujuan pinjaman dengan limit maksimal.';
        } else if (score >= 60) {
            return 'Pelanggan ini memiliki risiko kredit rendah. Dapat dipertimbangkan untuk memberikan pinjaman dengan limit sedang.';
        } else if (score >= 40) {
            return 'Pelanggan ini memiliki risiko kredit sedang. Perlu dilakukan penilaian tambahan sebelum memberikan pinjaman.';
        } else {
            return 'Pelanggan ini memiliki risiko kredit tinggi. Disarankan untuk melakukan penilaian lebih mendalam atau menolak permohonan.';
        }
    },

    view: function() {
        return m("div", { class: "max-w-4xl mx-auto p-6" }, [
            m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow-md p-6" }, [
                m("div", { class: "mb-6" }, [
                    m("h1", { class: "text-2xl font-bold text-gray-800 dark:text-white flex items-center" }, [
                        m("i", { class: "ri-brain-line mr-3 text-orange-500" }),
                        "Prediksi Kelancaran Pinjaman"
                    ])
                ]),
                m("div", { class: "space-y-6" }, [
                    // Prediction Result
                    this.predictionResult ? m("div", { class: "mt-8 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6" }, [
                        m("h3", { class: "text-lg font-semibold text-blue-800 dark:text-blue-200 mb-4" }, "Hasil Prediksi Kelancaran"),
                        m("div", { class: "space-y-3" }, [
                            m("div", { class: "flex justify-between items-center" }, [
                                m("span", { class: "font-medium text-gray-700 dark:text-gray-300" }, "Nama:"),
                                m("span", { class: "text-gray-900 dark:text-white" }, this.formData.nama)
                            ]),
                            m("div", { class: "flex justify-between items-center" }, [
                                m("span", { class: "font-medium text-gray-700 dark:text-gray-300" }, "Skor Prediksi:"),
                                m("span", {
                                    class: `font-bold ${
                                        this.predictionResult.score >= 80 ? 'text-green-600' :
                                        this.predictionResult.score >= 60 ? 'text-blue-600' :
                                        this.predictionResult.score >= 40 ? 'text-yellow-600' : 'text-red-600'
                                    }`
                                }, `${this.predictionResult.score}/100 (${this.predictionResult.category})`)
                            ]),
                            m("div", [
                                m("span", { class: "font-medium text-gray-700 dark:text-gray-300 block mb-2" }, "Rekomendasi:"),
                                m("p", { class: "text-sm text-gray-600 dark:text-gray-400 leading-relaxed" }, this.predictionResult.recommendation)
                            ])
                        ])
                    ]) : null,
                    m("form", {
                        onsubmit: this.handleSubmit.bind(this),
                        class: "space-y-6"
                    }, [
                        // Nama field
                        m("div", [
                            m("label", {
                                class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2",
                                for: "nama"
                            }, "Nama"),
                            m("input", {
                                type: "text",
                                id: "nama",
                                name: "nama",
                                value: this.formData.nama,
                                required: true,
                                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-orange-500 focus:border-orange-500 dark:bg-gray-700 dark:text-white",
                                placeholder: "Masukkan nama lengkap",
                                oninput: (e) => this.handleInputChange("nama", e.target.value)
                            })
                        ]),

                        // Status Pernikahan field
                        m("div", [
                            m("label", {
                                class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3"
                            }, "Status Pernikahan"),
                            m("div", { class: "space-y-2" }, [
                                m("label", { class: "flex items-center" }, [
                                    m("input", {
                                        type: "radio",
                                        value: "MENIKAH",
                                        name: "status_pernikahan",
                                        required: true,
                                        checked: this.formData.status_pernikahan === "MENIKAH",
                                        class: "mr-2 text-orange-600 focus:ring-orange-500",
                                        onchange: (e) => this.handleInputChange("status_pernikahan", e.target.value)
                                    }),
                                    m("span", { class: "text-sm text-gray-700 dark:text-gray-300" }, "Menikah")
                                ]),
                                m("label", { class: "flex items-center" }, [
                                    m("input", {
                                        type: "radio",
                                        value: "CERAI",
                                        name: "status_pernikahan",
                                        required: true,
                                        checked: this.formData.status_pernikahan === "CERAI",
                                        class: "mr-2 text-orange-600 focus:ring-orange-500",
                                        onchange: (e) => this.handleInputChange("status_pernikahan", e.target.value)
                                    }),
                                    m("span", { class: "text-sm text-gray-700 dark:text-gray-300" }, "Cerai hidup / mati")
                                ]),
                                m("label", { class: "flex items-center" }, [
                                    m("input", {
                                        type: "radio",
                                        value: "SINGLE",
                                        name: "status_pernikahan",
                                        required: true,
                                        checked: this.formData.status_pernikahan === "SINGLE",
                                        class: "mr-2 text-orange-600 focus:ring-orange-500",
                                        onchange: (e) => this.handleInputChange("status_pernikahan", e.target.value)
                                    }),
                                    m("span", { class: "text-sm text-gray-700 dark:text-gray-300" }, "Belum menikah")
                                ])
                            ])
                        ]),

                        // Status Rumah field
                        m("div", [
                            m("label", {
                                class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3"
                            }, "Status Rumah"),
                            m("div", { class: "space-y-2" }, [
                                m("label", { class: "flex items-center" }, [
                                    m("input", {
                                        type: "radio",
                                        value: "Sendiri",
                                        name: "status_rumah",
                                        required: true,
                                        checked: this.formData.status_rumah === "Sendiri",
                                        class: "mr-2 text-orange-600 focus:ring-orange-500",
                                        onchange: (e) => this.handleInputChange("status_rumah", e.target.value)
                                    }),
                                    m("span", { class: "text-sm text-gray-700 dark:text-gray-300" }, "Rumah sendiri")
                                ]),
                                m("label", { class: "flex items-center" }, [
                                    m("input", {
                                        type: "radio",
                                        value: "Kontrak",
                                        name: "status_rumah",
                                        required: true,
                                        checked: this.formData.status_rumah === "Kontrak",
                                        class: "mr-2 text-orange-600 focus:ring-orange-500",
                                        onchange: (e) => this.handleInputChange("status_rumah", e.target.value)
                                    }),
                                    m("span", { class: "text-sm text-gray-700 dark:text-gray-300" }, "Kontrak")
                                ])
                            ])
                        ]),

                        // Penghasilan field
                        m("div", [
                            m("label", {
                                class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2",
                                for: "penghasilan"
                            }, "Penghasilan"),
                            m("input", {
                                type: "text",
                                id: "penghasilan",
                                name: "penghasilan",
                                value: this.formData.penghasilan,
                                required: true,
                                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-orange-500 focus:border-orange-500 dark:bg-gray-700 dark:text-white",
                                placeholder: "Contoh: 5.000.000",
                                oninput: this.handleIncomeInput.bind(this)
                            })
                        ]),

                        // Umur field
                        m("div", [
                            m("label", {
                                class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2",
                                for: "umur"
                            }, "Umur"),
                            m("input", {
                                type: "text",
                                id: "umur",
                                name: "umur",
                                value: this.formData.umur,
                                required: true,
                                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-orange-500 focus:border-orange-500 dark:bg-gray-700 dark:text-white",
                                placeholder: "Contoh: 30",
                                oninput: (e) => this.handleInputChange("umur", e.target.value)
                            })
                        ]),

                        // Submit button
                        m("div", { class: "flex justify-end" }, [
                            m("button", {
                                type: "submit",
                                disabled: this.isLoading,
                                class: "px-6 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                            }, this.isLoading ? "Memproses..." : "Prediksi Kelancaran")
                        ])
                    ])
                ])
            ])
        ]);
    }
};

export default LoanPrediction;